
<script>
  import { request } from './../../helpers/api'
  import { locationStore, userStore, snackBarStore, tenantStore, peopleStore } from '../../state/store'
  import { isUserAdmin, getName } from './../../helpers/utils'
  import TextInput from '../../components/TextInput.svelte'
  import { replace } from 'svelte-spa-router'
  import { t } from '../../i18n/i18n'
  
  export let loc = {
    name: '',
    address: '',
    assignee: '',
    description: '',
    coordinates: []
  }
  let editing = false
  let autocomplete

  let form = {
    name: '',
    address: '',
    assignee: '',
    description: '',
    coordinates: [],
  }

  const initAutocomplete = () => {
    autocomplete = new google.maps.places.Autocomplete(
    (autocomplete),
    { types: ['geocode'] }
  )

    // When the user selects an address from the dropdown, populate the address
    // fields in the form.
    autocomplete.addListener('place_changed', () => {
      // Get the place details from the autocomplete object.
      form.address = autocomplete.getPlace().formatted_address
      form.coordinates[0] = autocomplete.getPlace().geometry.location.lng()
      form.coordinates[1] = autocomplete.getPlace().geometry.location.lat()
    })
  }

  const cancelEdit = () => {
    form.name = loc.name
    form.address = loc.address
    form.assignee = loc.assignee
    form.description = loc.description
    editing = false
  }

  const openEdit = () => {
    form.name = loc.name
    form.address = loc.address
    form.assignee = loc.assignee
    form.coordinates = loc.coordinates || []
    form.description = loc.description
    editing = true
    setTimeout(() => {
      initAutocomplete()
    }, 100)
  }

  const deleteLocation = async () => {
    if(confirm(`
      This will delete the location and all of this locations work logs permanently.
      Ensure that you have generated the reports needed for this location before deleting.
      
      This can not be undone.
    `)) {
      try {
       const response = await request({
        url: '/api/locations',
        method: 'DELETE',
        body: JSON.stringify({
          location: loc._id,
          tenant: $userStore.tenant_id,
        })
      })
      snackBarStore.set({ message: 'Location Deleted', type: 'success', selfDestruct: true  })
      replace('/locations/')
      } catch (error) {
        snackBarStore.set({ message: $t.something_wrong, type: 'error', selfDestruct: true }) 
      }
    }
  }

  const submitForm = async () => {   
    try {
      // Submit form data
      const response = await request({
        url: '/api/locations',
        method: 'PUT',
        body: JSON.stringify({
          ...form,
          tenant: $userStore.tenant_id,
          location: loc._id
        })
      })

      // Update location in the store
      locationStore.update((locations) => {
        let updatedLocation = locations.find(location => location._id === response._id)
        updatedLocation.name = response.name
        updatedLocation.address = response.address
        updatedLocation.assignee = response.assignee
        updatedLocation.coordinates = response.coordinates
        updatedLocation.description = response.description
        loc.address = response.address
        loc.coordinates = response.coordinates
        loc.assignee = response.assignee
        loc.description = response.description
        loc.name = response.name
        return [
          ...locations
        ]
      })
      snackBarStore.set({ message: $t['Location Updated'], type: 'success', selfDestruct: true  })
      cancelEdit()
    } catch (error) {
      snackBarStore.set({ message: $t.something_wrong, type: 'error', selfDestruct: true })
    }
  }

</script>


<style>
  select {
    width: 100%;
    margin-top: 1rem;
  }
  .auto-complete {
    display: block;
    width: 100%;
    font: inherit;
    border: 2px solid #ccc;
    background: #f7f7f7;
    padding: .15rem .5rem;
    transition: border-color .1s ease-out;
  }

  textarea {
    width: 100%;
  }

  header > div {
    margin-top: 2.6rem;
  }

  p {
    margin-top: 1.6rem;
  }

  p:last-child {
    margin-top: 0;
  }

</style>
<header>
  {#if !editing}
    {#if loc.name}
      <h1>{loc.name}</h1>
    {/if}
    <div>
      <div>
        {#if loc.coordinates}
          <a target="_blank" rel="noreferrer" href="https://www.google.com/maps/search/?api=1&query={loc.coordinates[1]},{loc.coordinates[0]}">{loc.address}</a>
        {/if}
      </div>
      {#if isUserAdmin($userStore) && loc.assignee}
        <p>{$t.assignee}: {getName($peopleStore, loc.assignee)}</p>
      {/if}
      {#if loc.description}<p>{$t.description}: {loc.description}</p>{/if}
    </div>
  {:else}
  <form on:submit|preventDefault={submitForm}>
    <TextInput
    id='name'
    label='{$t['Location Name']}'
    validityMessage='{$t['Please enter a Location name']}'
    on:input={event => (form.name = event.target.value)}
    value="{loc.name}" />
    <div class="form-control">
      <label for="address">{$t.address}</label>
      <input
        type="text"
        id='address'
        class="auto-complete"
        value={loc.address}
        bind:this={autocomplete}
        placeholder=""
      >
    </div>
    <div class="form-control">
      <label for="description">{$t.description}</label>
      <textarea name="description" id="description" value={loc.description}  cols="30" rows="6" on:input={event => (form.description = event.target.value)}></textarea>
    </div>
    <label for="User">{$t.assignee}</label>
    <select 
      name="Assignee" 
      id="Assignee" 
      on:input={event => (form.assignee = event.target.value)}
      value="{loc.assignee}" >
      <option value=''>{$t['Select Assignee']}</option>
      {#each $peopleStore as data, index}
        <option value={data._id}>{data.name}</option>
      {/each}
    </select>
    <div class="g-admin-buttons">
      <button on:click={cancelEdit} type="button">{$t.cancel}</button>
      <button class="update" type="submit"> {$t.update} </button>
      <button class="delete" type="button" on:click={deleteLocation}> {$t.delete} </button>
    </div>
  </form>

  {/if}
  {#if isUserAdmin($userStore)}
    {#if !editing}
      <div class="g-admin-buttons">
        <button on:click={openEdit} type='button' action='edit'>{$t.edit}</button>
      </div>
    {/if}
  {/if}
</header>
